module.exports = __webpack_public_path__ + "img/login-pic.92033ef7.jpg";